import { module } from 'modujs';
import { html } from '../utils/environment'

export default class extends module {
    constructor(m) {
        super(m);

        this.events = {
            click: {
                code: 'copyUrl',
                close: 'close'
            }
        }
    }

    init() {
        this.code = this.getData('code') || false

        setTimeout(() => {
            html.classList.add('has-alert-open');
        }, 3000)
    }

    copyUrl() {
        if(this.copyTimeout != undefined) {
            clearTimeout(this.copyTimeout);
        }
        this.$('code')[0].innerText = this.getData('copy-success');

        this.copyTimeout = setTimeout(() => {
            this.$('code')[0].innerText = this.getData('copy-label');
        }, 1500)

        window.copyToClipboard(this.code)
    }

    close() {
        html.classList.remove('has-alert-open');
    }

    destroy() {
        super.destroy()
    }
}
